<section
  class="product-category"
  [attr.data-cy]="'product-category-' + name"
  (click)="onClickCategory()"
>
  <img
    *ngIf="imgSource"
    src="{{ imgSource }}"
    alt="{{ alternativeText }}"
    title="{{ alternativeText }}"
    [attr.data-cy]="'product-image-' + alternativeText"
  />
  <span [attr.data-cy]="'product-label-' + name">{{ name }}</span>
</section>
